import { Util } from 'playback-web-player';

import inferStreamingProtocol from '../../Utils/inferStreamingProtocol';

/**
 * @param {Observable<[Asset, Config]>} assetUpdateWithConfig$
 * @param {Observable}
 */

const subscribeToAssetUpdateWithConfig = (
    assetUpdateWithConfig$,
    playbackApiRequest$
) =>
    assetUpdateWithConfig$
        .subscribe(([latestAsset, latestConfig]) => {
            const { environment } = latestConfig;
            const { authToken, playerId, platform, language } = environment;

            const userDevice = Util.getUserDevice(window.navigator.userAgent);
            const assetFormat = inferStreamingProtocol(userDevice);

            if (typeof authToken !== 'string' || !authToken) {
                throw new TypeError('A valid `authToken` must be provided');
            }

            const request = {
                assetId: latestAsset.assetId,
                playerId,
                platform,
                language,
                assetFormat,
                authToken,
            };

            playbackApiRequest$.next(request);
        });

export default subscribeToAssetUpdateWithConfig;
